<template>
  <div :class="[additionalClasses, 'seed-point-score']">
    <h3>
      <span v-html="headline"></span>
      <span class="seed-point-score__score my-2 my-m-0" v-if="points" v-text="points"></span>
    </h3>
    <a v-if="link" class="link-more link-more--long" :href="link.href">{{ link.description }}</a>
    <div v-if="apiError" class="col-12 error-box mb-3" v-text="translate('lblApiError')"></div>
  </div>
</template>

<script>
import LoyaltyUserApiConnectorMixin from './mixins/LoyaltyApiConnectorMixin';

export default {
  name: 'SeedPointScore',
  data: () => ({
    points: NaN,
    apiError: false,
  }),
  props: {
    additionalClasses: String,
    link: Object,
    headline: String,
    locale: String,
    translations: Object,
  },
  mixins: [LoyaltyUserApiConnectorMixin],
  async created() {
    if (this.translations) {
      this.addDictionary(this.translations);
    }
    const result = await this.getUserApiResult();
    if (result.point_summary) {
      this.points = result.point_summary.point_sum.toLocaleString(this.locale);
    }
  },
};
</script>

<style lang="scss">
.seed-point-score {
  h3 {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: .5em;
    flex-wrap: wrap;

    span {
      font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
      font-size: rem(24px);
      line-height: rem(29px);
      font-weight: 700;

      &.seed-point-score__score {
        font-size: rem(32px);
      }
    }
  }
}
</style>
